// extracted by extract-css-chunks-webpack-plugin
module.exports = {"annual-interest-rate":"_pUZbi"};